// extracted by mini-css-extract-plugin
export default {"button":"CustomSelectInput_button__t6XOi","wrapper":"CustomSelectInput_wrapper__oLcFS","dropdown":"CustomSelectInput_dropdown__nd858"};